import React, { useEffect, useState } from "react";
import { Button, Row, Card } from "reactstrap";
import { Colxx, Separator } from "components/common/CustomBootstrap";

import AppLayout from "layout/AppLayout";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axiosClient";
import { useToken } from "auth/useToken";
import ListingTable from "components/ListingTable";
import moment from "moment";

const EnquiriesList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [count, setCount] = useState(1);
  const [token, setToken] = useToken();

  useEffect(() => {
    let isMounted = true;
    axios
      .get(`/enquiries?page=${currentPage}&per_page=10`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((result) => {
        if (isMounted) {
          const { enquiries, count, page, pageCount } = result.data;
          setData(enquiries);
          setCount(count);
          setCurrentPage(page);
          setTotalPage(pageCount);
          setLoading(false);
        }
      });
    return () => {
      isMounted = false;
    };
  }, []);

  const navigate = useNavigate();

  const onSearchKey = (e) => {
    if (e.key === "Enter") {
      setLoading(true);
      handleSearch(e.target.value.toLowerCase());
    }
  };

  const handleSearch = (currentPage, selectedPageSize, word) => {
    ///
    axios
      .get(
        `/enquiries?search=${word}&page=${currentPage}&per_page=${selectedPageSize}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((result) => {
        const { enquiries, count, page, pageCount } = result.data;
        setData(enquiries);
        setCount(count);
        setCurrentPage(page);
        setTotalPage(pageCount);
        setLoading(false);
      });
  };

  const cols = React.useMemo(
    () => [
      {
        Header: "#",
        // accessor: "title",
        cellClass: "list-item-heading w-5",
      },
      {
        Header: "Video name",
        accessor: "input",
        cellClass: "list-item-heading w-35",
        Cell: (props) => {
          return <>{props.value.match(/_input_(.*)/)[1]}</>;
        },
      },
      {
        Header: "Duration (sec)",
        accessor: "duration",
        cellClass: "text-muted w-15",
        Cell: (props) => <>{props.value}</>,
      },
      {
        Header: "User",
        accessor: "user.firstName",
        cellClass: "text-muted w-35",
        Cell: (props) => <>{props.value}</>,
      },
      {
        Header: "Created At",
        accessor: "createdAt",
        cellClass: "text-muted w-25",
        Cell: (props) => <>{moment(props.value).format("DD/MM/YYYY HH:mm")}</>,
      },
    ],
    []
  );

  return (
    <AppLayout>
      <div className="dashboard-wrapper">
        <Row>
          <Colxx xxs="12">
            <div className="mb-2">
              <h1>Convereted Videos List</h1>
              <div className="text-zero top-right-button-container"></div>
            </div>
            <Separator className="mb-5" />
          </Colxx>
        </Row>
        <ListingTable
          columns={cols}
          data={data}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          handleSearch={handleSearch}
          totalPage={totalPage}
          totalItemCount={count}
          loading={loading}
        />
      </div>
    </AppLayout>
  );
};

export default EnquiriesList;
